import { network } from 'services/network';

export const removeVersion = (params) => {
    return network.post('api/bo/removeVersion', { ids: params.ids });
};
